import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';


class CFV2Services {

  createCFV2 = async (payload) => {
    const cfV2 = await Helpers.post({
      url: Constants.CFV2,
      data: payload,
    });
    return cfV2;
  }


  updateCFV2 = async (payload) => {
    const cfV2 = await Helpers.put({
      url: Constants.CFV2,
      data: payload,
    });
    return cfV2;
  }


  updateCFV2Status = async (payload) => {
    const po = await Helpers.post({
      url: Constants.CF_STATUS,
      data: payload,
    });
    return po;
  }


  getCFV2 = async (orgId, entityName, cfV2Id, page, limit) => {
    let url = `${Constants.CFV2}/global?`;
    if (orgId) url += `org_id=${orgId}&`;
    if (entityName) url += `entity_name=${entityName}&`;
    if (limit) url += `limit=${limit}&`;
    if (page) url += `page=${page}&`;
    const cfV2 = await Helpers.get({ url });
    return cfV2;
  }

  getDocCFV2 = async (orgId, entityName,) => {
    let url = `${Constants.CFV2}?`;
    if (orgId) url += `org_id=${orgId}&`;
    if (entityName) url += `entity_name=${entityName}&`;
    const cfDocV2 = await Helpers.get({ url });
    return cfDocV2;
  }

  deleteCFV2 = async (orgId, cfV2Id) => {
    const deleteCFV2 = await Helpers.delete({
      url: Constants.CF,
      data: {
        org_d: orgId,
        cfV2_id: cfV2Id,
      },
    });
    return deleteCFV2;
  }
}
export default new CFV2Services();
